module.exports = __webpack_public_path__ + "static/media/blue-action.8fc79ffc.svg";